import ToolPage from 'components/ToolPage';
import { toolAPI } from 'utils/api';
export default function PDFToZip() {
  return <ToolPage
    seoTitle="Files to ZIP — Free Online"
    seoDesc="Pack multiple files into one ZIP archive online, free. No signup required."
    path="/tools/pdf/to-zip"
    seoKey="pdf-to-zip"
    iconName="zip" title="Files to ZIP" desc="Select multiple files and compress them into a single ZIP archive." accept=".pdf,.doc,.docx,image/*" multiple hint="Select multiple files — PDF, images, documents · Max 50MB total" buttonLabel="Create ZIP Archive" apiCall={toolAPI.pdfToZip} outputFilename="devlayar-files.zip" infoText="All selected files are packaged into a single compressed ZIP file for easy sharing." />;
}
